import useCreations from './useCreations';
import CreationsCharts, {
    Data as ChartData,
} from 'Modules/Plans/Audios/AudioModal/components/CreationsCharts/CreationsCharts';
import { DateRangeFilter } from '@round/whitelabel-ui';
import { useState } from 'react';
import styles from './Creations.module.css';
import moment from 'moment/moment';
import cn from 'classnames';

type Props = {
    audioId: number | null | undefined;
    className?: string;
};

const Creations = ({ audioId, className }: Props) => {
    const today = moment();
    const twoWeeksAgo = moment().subtract(2, 'weeks');

    const [date, setDate] = useState<[Date] | [Date, Date] | null | undefined>([twoWeeksAgo.toDate(), today.toDate()]);
    const [startDate, endDate] = date ?? [];

    const { result } = useCreations({
        audioId,
        start_date: (startDate ? moment(startDate) : twoWeeksAgo).format('YYYY-MM-DD'),
        end_date: (endDate ? moment(endDate) : today).format('YYYY-MM-DD'),
    });

    const data: ChartData = {
        totals: {
            data: result.data?.totals || [],
            borderColor: '#2A94FF',
        },
        daily: {
            data: result.data?.daily || [],
            borderColor: '#2A94FF',
        },
    };

    return (
        <div className={cn(styles.container, className)}>
            <div className={styles.filters}>
                <DateRangeFilter value={date} onChange={setDate} maxDate={today.toDate()} />
            </div>

            <CreationsCharts data={data} isLoading={result.isPending} hasError={result.isError} />
        </div>
    );
};

export default Creations;
